export default __webpack_public_path__ + "static/media/941.5a8ede1e.svg";